import {useParams} from "react-router-dom";
import {Tabs} from "antd";
import {FontAwesomeIcon, PageHeader, Loading, ProjectQuota, ProjectToolNav} from "~/components";
import {useGetProjectQuery} from "~/reduxs/api/projectApiSlice";
import AiAssistant from "../components/AiAssistant";
import AiGenerator from "../components/AiGenerator";
import AiHistoryList from "../components/AiHistoryList";

/**
 * AI SEO TRONG 1 DỰ ÁN (`/projects/:id/ai`). Khác màn AI độc lập ở chỗ có tab
 * "Trợ lý AI" (#30) — chatbot phân tích website dựa trên dữ liệu crawl/SEO/GSC/PSI
 * đã có của chính dự án. Tab "Sinh nội dung" tái dùng bộ tác vụ #4 (gắn project_id).
 */
function AiProjectHome() {

	const {id} = useParams();

	const {data: project, isLoading} = useGetProjectQuery(id);

	if (isLoading) return <Loading />;

	const items = [
		{
			key: 'assistant',
			label: <span><FontAwesomeIcon icon="fa-light fa-robot" /> Trợ lý AI</span>,
			children: <AiAssistant projectId={id} />,
		},
		{
			key: 'generate',
			label: <span><FontAwesomeIcon icon="fa-light fa-wand-magic-sparkles" /> Sinh nội dung</span>,
			children: <AiGenerator projectId={id} />,
		},
		{
			key: 'history',
			label: <span><FontAwesomeIcon icon="fa-light fa-clock-rotate-left" /> Lịch sử</span>,
			children: <AiHistoryList projectId={id} />,
		},
	];

	return (
		<div className="container">
			<ProjectToolNav projectId={id} active="ai" />

			<PageHeader
				icon="fa-light fa-robot"
				title="AI SEO"
				subtitle={project?.root_url}
				actions={<ProjectQuota tool="ai" />}
			/>

			<Tabs defaultActiveKey="assistant" items={items} />
		</div>
	);
}

export default AiProjectHome;
